__turbopack_context__.v({
  "actions": "CRegisterationToNewsletters-module__Suhnja__actions",
  "categories": "CRegisterationToNewsletters-module__Suhnja__categories",
  "consents": "CRegisterationToNewsletters-module__Suhnja__consents",
  "fieldError": "CRegisterationToNewsletters-module__Suhnja__fieldError" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["errorText"],
  "fieldsGrid": "CRegisterationToNewsletters-module__Suhnja__fieldsGrid",
  "fieldset": "CRegisterationToNewsletters-module__Suhnja__fieldset",
  "form": "CRegisterationToNewsletters-module__Suhnja__form" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["form"],
  "intro": "CRegisterationToNewsletters-module__Suhnja__intro",
  "legend": "CRegisterationToNewsletters-module__Suhnja__legend",
  "root": "CRegisterationToNewsletters-module__Suhnja__root",
});
